module.exports = __webpack_public_path__ + "img/ajani.9820b7b9.jpg";